<template>
  <fieldset>
    <div class="form-wrap">

      <div>
        <label for="flight-number">Flight Number</label>
        <input
          id="flight-number"
          type="text"
          v-model="$parent.flight.flight_number"
        />
      </div>

      <div>
        <label for="departure_airport_id">Departure Airport</label>
        <v-select
          index="id"
          id="departure_airport_id"
          label="airport_name"
          :filterable="false"
          :options="departure_airports"
          v-model="$parent.flight.departure_airport_id"
          v-debounce:500ms="searchDepartureAirports"

        > 
          <template slot="option" slot-scope="option" >
            {{ option.iata_code }} - {{ option.airport_name }}
          </template>
        </v-select>
      </div>

      <div>
        <label for="arrival_airport_id">Arrival Airport</label>
        <v-select
          index="id"
          id="arrival_airport_id"
          label="airport_name"
          :filterable="false"
          :options="arrival_airports"
          v-model="$parent.flight.arrival_airport_id"
          v-debounce:500ms="searchArrivalAirports"
        >
          <template slot="option" slot-scope="option">
            {{ option.iata_code }} - {{ option.airport_name }}
          </template>
        </v-select>
      </div>
      
      <div>
        <label for="departure_terminal">Departure Terminal</label>
        <input 
          title="departure_terminal"
          type="text"
          id="depature_terminal"
          placeholder=""
          v-model="$parent.flight.departure_terminal"
        />
      </div>

      <div>
        <label for="arrival_terminal">Arrival Terminal</label>
        <input 
          title="arrival_terminal"
          type="text"
          id="arrival_terminal"
          placeholder=""
          v-model="$parent.flight.arrival_terminal"
        />
      </div>      

      <div>
        <label for="flight_cost">Flight Cost</label>
        <input 
          title="flight_cost"
          type="text"
          id="flight_cost"
          placeholder=""
          v-model="$parent.flight.flight_cost"
        />
      </div>

      <div>
        <label for="flight_price">Flight Price</label>
        <input 
          title="flight_price"
          type="text"
          id="flight_price"
          pacholder=""
          v-model="$parent.flight.flight_price"
        />
      </div>      

      <div>
        <label for="departure-time">Range Start Date</label>
        <dateTimePicker no-label id="departure-time" format="YYYY-MM-DD HH:mm:ss" v-model="$parent.flight.departure_time" button-color="#ec391e" color="#ec391e"/>
      </div>

       <div>
        <label for="arrival-time">Range End Date</label>
        <dateTimePicker no-label id="arrival-time" format="YYYY-MM-DD HH:mm:ss" v-model="$parent.flight.arrival_time" button-color="#ec391e" color="#ec391e"/>
      </div>

      <div>
        <label for="airline">Airline</label>
        <input
          id="airline"
          type="text"
          v-model="$parent.flight.airline"
        />
      </div>

      <div>
        <input 
          type="checkbox"
          id="sunday"
          name="sunday"
          value="sunday"
          v-model="$parent.flight.sunday"
        >
        <label for="sunday">Sunday</label>
        <input 
          type="checkbox"
          id="monday"
          name="monday"
          value="monday"
          v-model="$parent.flight.monday"
        >
        <label for="sunday">Monday</label>

        <input 
          type="checkbox"
          id="tuesday"
          name="tuesday"
          value="tueday"
          v-model="$parent.flight.tuesday"
        >
        <label for="tuesday">Tuesday</label>

        <input 
          type="checkbox"
          id="wednesday"
          name="wednesday"
          value="wednesday"
          v-model="$parent.flight.wednesday"
        >
        <label for="wednesday">Wednesday</label>
        <input 
          type="checkbox"
          id="thursday"
          name="thursday"
          value="thursday"
          v-model="$parent.flight.thursday"
        >
        <label for="thursday">Thursday</label>

        <input 
          type="checkbox"
          id="friday"
          name="friday"
          value="friday"
          v-model="$parent.flight.friday"
        >
        <label for="friday">Friday</label>

        <input 
          type="checkbox"
          id="saturday"
          name="saturday"
          value="saturday"
          v-model="$parent.flight.saturday"
        >
        <label for="saturday">Saturday</label>
      </div>

      <div>
        <label for="stop-sell">Stop sell</label>
        <label class="switch">
          <input id="stop-sell" name="stop_sell" type="checkbox" v-model="$parent.flight.stop_sell">
          <span class="switch__slider"></span>
        </label>
      </div>

    </div>
  </fieldset>
</template>

<script>
export default {
  name: 'MultipleFlightFields',
  data () {
    return {
      loading: false,
      departure_airports: [],
      arrival_airports: [],
    }
  },
  methods: {
    searchDepartureAirports (search) {
      if(this.$data.loading === false ) {
        this.$data.loading = true
        fetch(this.$api + 'airports/search/' + search, {
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.$data.departure_airports = response.data
          this.$data.loading = false
        })
      }
    },
    searchArrivalAirports (search) {
      if(this.$data.loading === false ) {
        this.$data.loading = true
        fetch(this.$api + 'airports/search/' + search, {
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.$data.arrival_airports = response.data
          this.$data.loading = false
        })
      }
    }
  }
}
</script>
